import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { environment } from 'src/environments/environment';
import { MaintenanceStrategyModel } from 'src/app/models/archive/maintenance-strategy.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { MaintenanceStrategyImportModel } from 'src/app/models/imports/maintenance-strategy-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceStrategyService {

  constructor(private _httpClient: HttpClient) { }

  createMaintenanceStrategy(maintenanceStrategyModel: MaintenanceStrategyModel): Observable<MaintenanceStrategyModel> {
    return this._httpClient.post<MaintenanceStrategyModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceStrategy.CreateAsync}`,
      maintenanceStrategyModel);
  }

  deleteMaintenanceStrategy(maintenanceStrategyId: number): Observable<MaintenanceStrategyModel> {
    return this._httpClient.delete<MaintenanceStrategyModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceStrategy.DeleteAsync}/${maintenanceStrategyId}`);
  }

  deleteSomeDetails(maintenanceStrategyIds: number[]): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceStrategy.DeleteSomeDetailsAsync}`,
      maintenanceStrategyIds);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceStrategy.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceStrategy.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  getAllMaintenanceStrategiesWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, articleId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('articleId', articleId);
    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceStrategy.GetAllMaintenanceStrategiesWithPaginationAsync}`,
      { params: params }
    );
  }

  getAllUnitsForSelect(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceStrategy.GetAllUnitsForSelectAsync}`);
  }

  getAllMaintenancePlansForSelect(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceStrategy.GetMaintenancePlansAsync}`);
  }

  getMaintenancePlansByArticleAsync(articleId: number): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceStrategy.GetMaintenancePlansByArticleAsync}/${articleId}`);
  }

  getMaintenanceStrategyById(maintenanceStrategyId: number): Observable<MaintenanceStrategyModel> {
    return this._httpClient.get<MaintenanceStrategyModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceStrategy.GetByIdAsync}/${maintenanceStrategyId}`);
  }

  getColumnsForTableAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceStrategy.GetColumnsForTableAsync}`);
  }

  getLastMaintenanceStrategy(articleId: number): Observable<MaintenanceStrategyModel> {
    return this._httpClient.get<MaintenanceStrategyModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceStrategy.GetLastMaintenanceStrategyAsync}/${articleId}`);
  }

  getTotalMaintenanceStrategies(articleId: number): Observable<number> {
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceStrategy.GetTotalMaintenanceStrategiesAsync}/${articleId}`);
  }

  importMaintenanceStrategy(maintenanceStrategyImport: Array<MaintenanceStrategyImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceStrategy.ImportMaintenanceStrategy}`, maintenanceStrategyImport);
  }

  updateMaintenanceStrategy(maintenanceStrategyModel: MaintenanceStrategyModel): Observable<MaintenanceStrategyModel> {
    return this._httpClient.put<MaintenanceStrategyModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.maintenanceStrategy.UpdateAsync}`,
      maintenanceStrategyModel);
  }

}
